import axios from 'axios';
import { toast } from 'react-toastify';

let dummyResponse = {
  data: {
    isSuccess: false,
  },
};
let dummyResponse400;
const setErrorMessage = (message) => {
  dummyResponse400 = {
    data: {
      isSuccess: false,
      message: message,
    },
  };
  return dummyResponse400;
};

function handleBaseUrl(active) {
  let baseurl = process.env.REACT_APP_BASE_URL;
  let activeUrl = JSON.parse(process.env.REACT_APP_BASE_URL_LIST);
  if (!active) return;

  activeUrl.services.map((item) => {
    if (item.code === active) {
      baseurl = item.url;
    }
  });
  return baseurl;
}
export const getRequest = async (url, active = '') => {
  const baseurl = handleBaseUrl(active);
  try {
    let response = await axios.get(`${baseurl}${url}`);
    if (response && response?.data?.isSuccess) {
      return response;
    } else {
      const error = response?.data?.message ? response?.data?.message : 'Something Went Wrong';
      toast.error(error);
      return dummyResponse;
    }
  } catch (error) {
    if (error.response?.status === 400) {
      setErrorMessage(error?.response?.data?.errorMessage || error?.response?.data?.error || 'Something Went Wrong');
      return dummyResponse400;
    }

    if (error.response && (error.response?.status === 404 || error.response?.status === 500)) {
      toast.error('Something Went Wrong');
      return dummyResponse;
    }
    if (axios.isCancel(error)) {
      return dummyResponse;
    } else {
      return dummyResponse;
    }
  }
};

export const postRequest = async (url, payload, active = '', handleFileProgress = '') => {
  const baseurl = handleBaseUrl(active);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const offsetInMinutes = new Date().getTimezoneOffset();

  try {
    let response = await axios.post(
      `${baseurl}${url}`,
      {
        ...payload,
        timeZone: timeZone,
        timeZoneMinuteDifference: offsetInMinutes,
      },
      {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (handleFileProgress) {
            handleFileProgress(percentCompleted);
          }
        },
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (handleFileProgress) {
            handleFileProgress(percentCompleted);
          }
        },
      },
    );
    if ((response && response?.data.isSuccess) || response?.data.status === 200) {
      return response;
    } else {
      const error = response?.data?.message ? response?.data?.message : 'Something Went Wrong';
      toast.error(error);
      return dummyResponse;
    }
  } catch (error) {
    if (error.response?.status === 400) {
      setErrorMessage(
        error?.response?.data?.errorMessage ||
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Something Went Wrong',
      );
      return dummyResponse400;
    }
    if (axios.isCancel(error)) {
      return dummyResponse;
    }
    if (error.response && (error.response?.status === 404 || error.response?.status === 500)) {
      toast.error('Data Not Found');
      return dummyResponse;
    } else {
      const errorMessage = error.code === 'ERR_NETWORK' ? error.message : 'Something Went Wrong';
      toast.error(errorMessage);
      return dummyResponse;
    }
  }
};

export const putRequest = async (url, payload, active = '') => {
  const baseurl = handleBaseUrl(active);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const offsetInMinutes = new Date().getTimezoneOffset();
  try {
    let response = await axios.put(`${baseurl}${url}`, {
      ...payload,
      timeZone: timeZone,
      timeZoneMinuteDifference: offsetInMinutes,
    });
    if (response && response?.data.isSuccess) {
      return response;
    } else {
      const error = response?.data?.message ? response?.data?.message : 'Something Went Wrong';
      toast.error(error);
      return dummyResponse;
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      return dummyResponse;
    }

    if (error.response?.status === 400) {
      setErrorMessage(
        error?.response?.data?.errorMessage ||
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Something Went Wrong',
      );

      return dummyResponse400;
    }
    if (error.response && (error.response?.status === 404 || error.response?.status === 500)) {
      toast.error('Data Not Found');
      return dummyResponse;
    } else {
      const errorMessage = error.code === 'ERR_NETWORK' ? error.message : 'Something Went Wrong';
      toast.error(errorMessage);
      return dummyResponse;
    }
  }
};

export const uploadFileUpdateRequest = async (url, active = '') => {
  const baseurl = handleBaseUrl(active);
  try {
    let response = await axios.put(`${baseurl}${url}`, {});
    if (response && response?.data.isSuccess) {
      return response;
    } else {
      const error = response?.data?.message ? response?.data?.message : 'Something Went Wrong';
      toast.error(error);
      return dummyResponse;
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      return dummyResponse;
    }
    if (error.response?.status === 400) {
      setErrorMessage(error?.response?.data?.errorMessage);
      return dummyResponse400;
    }

    if (
      error.response &&
      (error.response?.status === 404 || error.response?.status === 400 || error.response?.status === 500)
    ) {
      toast.error('Data Not Found');
      return dummyResponse;
    } else {
      const errorMessage = error.code === 'ERR_NETWORK' ? error.message : 'Something Went Wrong';
      toast.error(errorMessage);
      return dummyResponse;
    }
  }
};

export const postRequestForUpload = async (url, payload, active = '', handleFileProgress = '') => {
  const baseurl = handleBaseUrl(active);

  try {
    let response = await axios.post(`${baseurl}${url}`, payload, {
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (handleFileProgress) {
          handleFileProgress(percentCompleted);
        }
      },
      onDownloadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (handleFileProgress) {
          handleFileProgress(percentCompleted);
        }
      },
    });

    if (response && response?.data.isSuccess) {
      return response;
    } else {
      const error = response?.data?.message ? response?.data?.message : 'Something Went Wrong';
      toast.error(error);
      return dummyResponse;
    }
  } catch (error) {
    if (error.response?.status === 400) {
      setErrorMessage(error?.response?.data?.errorMessage);
      return dummyResponse400;
    }
    if (axios.isCancel(error)) {
      return dummyResponse;
    }
    if (error.response && (error.response?.status === 404 || error.response?.status === 500)) {
      toast.error('Data Not Found');
      return dummyResponse;
    } else {
      const errorMessage = error.code === 'ERR_NETWORK' ? error.message : 'Something Went Wrong';
      toast.error(errorMessage);
      return dummyResponse;
    }
  }
};
